import * as types from './types';
import createReducer from '../../createReducer';
import { FETCH_STATE } from '../../../constants/common';

const initialState = {
  list: [],
  pagination: {},
  statement: {},
  fetchingList: FETCH_STATE.UNSENT,
  fetchingStatement: FETCH_STATE.UNSENT,
  processingBalance: FETCH_STATE.UNSENT,
  processingBalanceBulk: FETCH_STATE.UNSENT,
};

const accountStatementReducer = createReducer(initialState)({
  // GET ACCOUNT STATEMENT
  [types.FETCH_ACCOUNT_STATEMENTS_REQUEST]: (state) => {
    return {
      ...state,
      list: [],
      fetchingList: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_ACCOUNT_STATEMENTS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      list: payload.data,
      pagination: payload.pagination,
      fetchingList: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_ACCOUNT_STATEMENTS_FAILED]: (state) => {
    return {
      ...state,
      fetchingList: FETCH_STATE.ERROR,
    };
  },

  // GET ACCOUNT STATEMENT BY ID
  [types.FETCH_ACCOUNT_STATEMENT_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      statement: {},
      fetchingStatement: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_ACCOUNT_STATEMENT_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      statement: payload.data,
      fetchingStatement: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_ACCOUNT_STATEMENT_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      fetchingStatement: FETCH_STATE.ERROR,
    };
  },

  // PROCESS ACCOUNT STATEMENT BALANCE BY ID
  [types.PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      processingBalance: FETCH_STATE.LOADING,
    };
  },
  [types.PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_ID_SUCCESS]: (state) => {
    return {
      ...state,
      processingBalance: FETCH_STATE.DONE,
      fetchingList: FETCH_STATE.UNSENT,
    };
  },
  [types.PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      processingBalance: FETCH_STATE.ERROR,
    };
  },

  // PROCESS ACCOUNT STATEMENT BALANCE BY BULK
  [types.PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_BULK_REQUEST]: (state) => {
    return {
      ...state,
      processingBalanceBulk: FETCH_STATE.LOADING,
    };
  },
  [types.PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_BULK_SUCCESS]: (state) => {
    return {
      ...state,
      processingBalanceBulk: FETCH_STATE.DONE,
      // Mark the list stale so the page refetches, as the single-statement path does. The
      // charge is queued, so the first refetch may still show the old status.
      fetchingList: FETCH_STATE.UNSENT,
    };
  },
  [types.PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_BULK_FAILED]: (state) => {
    return {
      ...state,
      processingBalanceBulk: FETCH_STATE.ERROR,
    };
  },
});

export default accountStatementReducer;
